import React, {useState, useEffect, useContext} from 'react';
import {View, Platform} from 'react-native';
import Checkbox from '../../components/elements/Checkbox';
import Divider from '../../components/elements/Divider';
import Input from '../../components/elements/Input';
import {DIABETES_TYPES, KEYS} from '../../utils/Constants';
import {getData, storeUserProfileData} from '../../utils/GeneralStorage';
import {DLog} from '../../utils/HelperMethods';
import {fetchApi} from '../../utils/ApiHelper';
import {
  HTTP_METHODS,
  POST_DIABETES_TYPE,
  loginAndSaveDetailsGlobal,
} from '../../utils/URLConstants';
import makeStyles from './styles';
import {useThemedStyles} from '../../theme';
import {loadingPauseContext} from '../../contexts/LoadingPauseContext';
import {errorStatusContext} from '../../contexts/ErrorStatusContext';
import {tID} from '../../utils/TestIdHelper';
import CommonStyles from '../../utils/CommonStyles';
import UI from './ui';

const DiabetesType = ({navigation, authCredentials, ...props}) => {
  const styles = useThemedStyles(makeStyles);
  const [selectedType, setSelectedType] = useState([]);
  const [otherInput, setotherInput] = useState('');

  const lpc = useContext(loadingPauseContext);
  const esc = useContext(errorStatusContext);

  useEffect(() => {
    const getToken = async () => {
      const token = await getData(KEYS.userToken);
    };
    getToken();
  }, []);

  const onPressCheckbox = item => {
    if (selectedType.includes(DIABETES_TYPES[item])) {
      const idx = selectedType.indexOf(DIABETES_TYPES[item]);
      selectedType.splice(idx, 1);
      setSelectedType([...selectedType]);
    } else {
      setSelectedType([...selectedType, DIABETES_TYPES[item]]);
    }
  };

  const onPressSkip = () => {
    if (Platform.OS === 'web') {
      navigation('/home', {replace: true});
    } else {
      navigation.navigate('HomeTab');
    }
  };

  const onPressSave = async () => {
    let conditions = [];
    let otherType = null;

    selectedType.forEach(item => {
      if (item !== DIABETES_TYPES.Other) {
        conditions.push({conditionId: item});
      } else if (item === DIABETES_TYPES.Other) {
        otherType = {name: 'Diabetes', subtype: otherInput};
      }
    });
    const userId = await getData(KEYS.userId);
    DLog(userId, conditions);
    let postData = {
      patientId: parseInt(userId),
      conditions,
    };
    if (otherType) {
      postData['otherType'] = otherType;
    }
    lpc.setVisible(true);
    fetchApi(HTTP_METHODS.POST, POST_DIABETES_TYPE, postData)
      .then(response => {
        //now navigate to the sync bluetooth device screen
        loginAndSaveDetails();
      })
      .catch(error => {
        DLog(error);
        lpc.setVisible(false);
        esc.showError(error);
      });
  };

  const loginAndSaveDetails = async () => {
    loginAndSaveDetailsGlobal(
      authCredentials?.username,
      authCredentials?.password,
    )
      .then(async res => {
        lpc.setVisible(false);
        if (res.status === 200) {
          //store the received user token
          DLog(res.data.data);
          //below lines can be added if token refreshes on each login. Currently user token stays contant
          //await storeData(KEYS.userToken, res.data.data.token);
          //await storeData(KEYS.isLogin, USER_AUTH_STATUS.login);
          //await storeData(KEYS.userId, res.data.data.id);
          await storeUserProfileData(res.data.data);
          if (Platform.OS === 'web') {
            navigation('/home', {replace: true});
          } else {
            navigation.navigate('HomeTab');
          }
        }
      })
      .catch(e => {
        DLog(e);
        lpc.setVisible(false);
        esc.showError(e);
      });
  };

  const renderDiabetesTypeItem = (item, index) => {
    const selected = selectedType.includes(DIABETES_TYPES[item]);
    return (
      <View key={index}>
        <Checkbox
          testID={tID(`DiabetesType-Checkbox-${index + 1}`)}
          topMargin={16}
          title={item}
          selected={selected}
          onPress={() => onPressCheckbox(item)}
          titleStyle={styles.checkboxTitle}
          checkboxStyle={Platform.OS === 'web' ? styles.checkbox : {}}
        />
        <Divider top={16} />
      </View>
    );
  };

  const renderList = () => {
    return (
      <>
        {Object.keys(DIABETES_TYPES).map((item, index) =>
          renderDiabetesTypeItem(item, index),
        )}
        {selectedType.includes(DIABETES_TYPES.Other) && (
          <Input
            testID={tID('DiabetesType-Input-Other')}
            // hasError={hasError}
            placeholder={'Type here...'}
            topMargin={20}
            value={otherInput}
            onChangeText={setotherInput}
            containerStyle={
              Platform.OS === 'web' ? CommonStyles.max_width_292 : {}
            }
          />
        )}
      </>
    );
  };

  const uiProps = {
    navigation,
    selectedType,
    otherInput,
    onPressSave,
    onPressSkip,
    renderList,
    ...props,
  };

  return <UI {...uiProps} />;
};

export default DiabetesType;
